import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-feather";

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-card px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="mx-auto max-w-max">
        <main className="sm:flex">
          <p className="text-4xl font-bold tracking-tight text-brand-600 sm:text-5xl">
            404
          </p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-border sm:pl-6">
              <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
                Page not found
              </h1>
              <p className="mt-4 text-base text-muted-foreground">
                Sorry, we couldn't find the page you're looking for.
              </p>
            </div>
            <div className="mt-8 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center rounded-lg border border-border bg-card px-4 py-2 text-sm font-medium text-muted-foreground shadow-sm hover:bg-accent focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Go back
              </button>
              <Link
                to="/"
                className="inline-flex items-center rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
              >
                Go home
              </Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
